import { useModal, useUrlFilter, useUrlPagination } from '@/hooks';

import { MODAL_ROUTE } from '../../../../constants';
import { useGetStrengthQuery } from '../../../../features/slice/products/strength/strength-api-slice';

export const useStrengthList = () => {
    const { debouncedSearchText, sortBy, sortOrder } = useUrlFilter();
    const { page, limit } = useUrlPagination();
    const { openModal } = useModal();

    const { data, isLoading, isFetching, isError, error } = useGetStrengthQuery(
        {
            page,
            limit,
            search: debouncedSearchText,
            sort_by: sortBy,
            sort_order: sortOrder,
        },
    );

    const handleCreateStrength = () => {
        openModal(MODAL_ROUTE.CREATE_PRODUCT_STRENGTH);
    };

    return {
        data,
        isLoading,
        isFetching,
        isError,
        error,
        handleCreateStrength,
    };
};
